import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  additionalItemsHeader: {
    defaultMessage: 'Additional Items',
    description: 'Header for a section that shows additional items that were not included in the original order.',
    id: 'LFgpnw',
  },
  additionalItemsTooltip: {
    defaultMessage: 'These items were not included in the original order and will not be reflected in any updates made to the marketplace.',
    description: 'Tooltip explaining more about additional items',
    id: '5KZFZs',
  },
});
